<template>
  <p :class="props.paraClass" :id="props.paraClass" @click="props.clickHandler" v-if="props.condition" v-html="$t(props.labelKey)"></p>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps(['paraClass', 'clickHandler', 'condition', 'labelKey']);
</script>
